import reportitemproductioncostingService from '../../../services/reportitemproductioncostingService';
import filterService from '../../../services/filterService';

import {
    setReportitemproductioncostingLoading,
    setReportitemproductioncostingError,
    setReportitemproductioncostingList,
    setReportitemproductioncostingCurrent,
    setReportitemproductioncostingPagination,
    setReportitemproductioncostingSort,
    setReportitemproductioncostingFilters,
    setReportitemproductioncostingDefaultFilter,
    setReportitemproductioncostingSettings,
    clearReportitemproductioncostingCurrent,
    clearReportitemproductioncostingError,
    setReportitemproductioncostingFilterLoading,
    changeReportitemproductioncostingFilterCondition,
    addReportitemproductioncostingFilterCondition,
    updateReportitemproductioncostingFilterConditionRule,
    updateReportitemproductioncostingFilterConditionValue,
    removeReportitemproductioncostingFilterCondition,
    setReportitemproductioncostingSelected,
    setReportitemproductioncostingDownloading,
    resetReportitemproductioncostingFiltersAndPagination,

    setReportitemproductioncostingClassicFilters
} from './reportitemproductioncostingSlice';

export const fetchSettings = () => async (dispatch, getState) => {
    try {
        // Only fetch settings if they haven't been initialized
        if (!getState().reportitemproductioncosting.isSettingsInitialized) {
            dispatch(setReportitemproductioncostingLoading(true));
            const response = await reportitemproductioncostingService.getSettings();

            // Set the settings
            dispatch(setReportitemproductioncostingSettings(response));

            const classicFilters = response?.classic_filters || [];
            dispatch(setReportitemproductioncostingClassicFilters(classicFilters));

            const activeFilter = response.filters.find(filter => filter.mark_default === true)
            if (activeFilter) {
                dispatch(setReportitemproductioncostingDefaultFilter(activeFilter));
                return activeFilter;
            }
        }
        return {};
    } catch (error) {
        console.error('Error fetching settings:', error);
        dispatch(setReportitemproductioncostingError({
            message: error.message || 'Failed to fetch settings',
            errors: error.errors || {}
        }));
        return {};
    } finally {
        dispatch(setReportitemproductioncostingLoading(false));
    }
};

export const fetchReportitemproductioncostings = (params = {}, filter = {}, shouldUseFilter, externalCondition = {}) => async (dispatch, getState) => {
    try {
        // Check if settings are initialized

        const state = getState().reportitemproductioncosting;
        if (!state.isSettingsInitialized) {
            shouldUseFilter ? filter = await dispatch(fetchSettings()) : await dispatch(fetchSettings());
        }

        const finalQueryParams = {
            ...state.filters,
            page: state.pagination.current_page,
            per_page: state.pagination.per_page,
            sort_field: state.sort.field,
            sort_direction: state.sort.direction,
            ...params
        };

        const finalActiveFilter = shouldUseFilter ? (Object.keys(filter).length === 0 ? state.defaultFilter : { ...state.defaultFilter, ...filter }) : externalCondition;

        dispatch(setReportitemproductioncostingLoading(true));
        const response = await reportitemproductioncostingService.getList(finalQueryParams, finalActiveFilter, state.classicFilters);
        dispatch(setReportitemproductioncostingList(response));
        return response;
    } catch (error) {
        console.error('Error in fetchReportitemproductioncostings:', error);
        const serializedError = {
            message: error.message || 'An error occurred',
            errors: error.errors || {},
            status: error.status || 500
        };
        dispatch(setReportitemproductioncostingError(serializedError));
        throw serializedError;
    } finally {
        dispatch(setReportitemproductioncostingLoading(false));
    }
};

export const fetchReportitemproductioncosting = (id) => async (dispatch) => {
    try {
        dispatch(setReportitemproductioncostingLoading(true));
        const response = await reportitemproductioncostingService.getOne(id);
        dispatch(setReportitemproductioncostingCurrent(response.data));
    } catch (error) {
        dispatch(setReportitemproductioncostingError({
            message: error.message || 'An error occurred',
            errors: error.errors || {}
        }));
    } finally {
        dispatch(setReportitemproductioncostingLoading(false));
    }
};

export const createReportitemproductioncosting = (data) => async (dispatch) => {
    try {
        const response = await reportitemproductioncostingService.create(data);
        return response.data || response;
    } catch (error) {
        const serializedError = {
            message: error.message || 'An error occurred',
            errors: error.errors || {}
        };
        throw serializedError;
    }
};

export const updateReportitemproductioncosting = (id, data) => async (dispatch) => {
    try {
        const response = await reportitemproductioncostingService.update(id, data);
        return response.data || response;
    } catch (error) {
        const serializedError = {
            message: error.message || 'An error occurred',
            errors: error.errors || {}
        };
        throw serializedError;
    }
};

export const deleteReportitemproductioncosting = (id) => async (dispatch) => {
    try {
        dispatch(setReportitemproductioncostingLoading(true));
        const response = await reportitemproductioncostingService.delete(id);
        return response;
    } catch (error) {
        const serializedError = {
            message: error.message || 'An error occurred',
            errors: error.errors || {}
        };
        dispatch(setReportitemproductioncostingError(serializedError));
        throw serializedError;
    } finally {
        dispatch(setReportitemproductioncostingLoading(false));
    }
};

export const downloadReportitemproductioncosting = (type) => async (dispatch, getState) => {
    try {
        const state = getState().reportitemproductioncosting;

        const finalQueryParams = {
            ...state.filters,
            page: state.pagination.current_page,
            per_page: state.pagination.per_page,
            sort_field: state.sort.field,
            sort_direction: state.sort.direction,
            export_type: type
        };

        const filter = state.defaultFilter;
        dispatch(setReportitemproductioncostingDownloading(true));
        const response = await reportitemproductioncostingService.downloadAsync(finalQueryParams, filter, state.classicFilters);
        dispatch(setReportitemproductioncostingDownloading(false));

        return response;
    } catch (error) {
        console.error('Error downloading reportitemproductioncostings:', error);
        const serializedError = {
            message: error.message || 'An error occurred',
            errors: error.errors || {},
            status: error.status || 500
        };
        dispatch(setReportitemproductioncostingError(serializedError));
        throw serializedError;
    } finally {
        dispatch(setReportitemproductioncostingDownloading(false));
    }
};

export const setPagination = (pagination) => (dispatch) => {
    dispatch(setReportitemproductioncostingPagination(pagination));
};

export const setSort = (sort) => (dispatch) => {
    dispatch(setReportitemproductioncostingSort(sort));
};

export const searchReportitemproductioncostings = (query) => (dispatch, getState) => {
    const currentFilters = getState().reportitemproductioncosting.filters;
    dispatch(setReportitemproductioncostingFilters({ ...currentFilters, search: query }));
};

// New filter-related actions
export const setDefaultFilter = (data) => {
    return async (dispatch) => {
        try {
            await dispatch(setReportitemproductioncostingDefaultFilter(data));
        } catch (error) {
            console.error('Error setting default filter:', error);
        }
    };
};

export const changeCondition = (condition) => {
    return (dispatch) => {
        dispatch(changeReportitemproductioncostingFilterCondition(condition));
    };
};

export const addNewCondition = (rule) => {
    return (dispatch) => {
        dispatch(addReportitemproductioncostingFilterCondition(rule));
    };
};

export const updateOptionRule = (index, data) => {
    return (dispatch) => {
        dispatch(updateReportitemproductioncostingFilterConditionRule({ index, data }));
    };
};

export const updateOptionValue = (index, value) => {
    return (dispatch) => {
        dispatch(updateReportitemproductioncostingFilterConditionValue({ index, value }));
    };
};

export const removeCondition = (index) => {
    return (dispatch) => {
        dispatch(removeReportitemproductioncostingFilterCondition(index));
    };
};

export const saveFilterCondition = (filterData) => async (dispatch, getState) => {
    try {
        dispatch(setReportitemproductioncostingFilterLoading(true));
        const response = await filterService.createFilterCondition(filterData);
        if (!response?.errors) {
            const currentSettings = getState().reportitemproductioncosting.settings;
            dispatch(setReportitemproductioncostingSettings({ ...currentSettings, filters: response.filters }));
        }
        dispatch(setReportitemproductioncostingFilterLoading(false));
        return response;
    } catch (error) {
        console.error('Error saving filter:', error);
        dispatch(setReportitemproductioncostingFilterLoading(false));
        dispatch(setReportitemproductioncostingError({
            message: error.message || 'Failed to save filter',
            errors: error.errors || {}
        }));
        throw error;
    }
};

export const setSelected = (selectedRows) => {
    return (dispatch) => {
        dispatch(setReportitemproductioncostingSelected(selectedRows));
    };
};

export const clearCurrentReportitemproductioncosting = () => {
    return (dispatch) => {
        dispatch(clearReportitemproductioncostingCurrent());
    };
};

export const resetFiltersAndPagination = () => (dispatch) => {
    dispatch(resetReportitemproductioncostingFiltersAndPagination());
};

export const changeClassicFilter = (name, value) => (dispatch, getState) => {
    const currentClassicFilters = getState().reportitemproductioncosting.classicFilters;

    // Create a deep copy of the classic filters
    const updatedClassicFilters = { ...currentClassicFilters };
    
    // Update the nested value in the query object
    if (updatedClassicFilters[name]) {
        updatedClassicFilters[name] = {
            ...updatedClassicFilters[name],
            query: {
                ...updatedClassicFilters[name].query,
                ...(typeof value === 'object' && value !== null ? value : { value })
            }
        };
    }

    dispatch(setReportitemproductioncostingClassicFilters(updatedClassicFilters));
};